import { render, staticRenderFns } from "./FooterLogos.vue?vue&type=template&id=4e5ca1e1&"
import script from "./FooterLogos.vue?vue&type=script&lang=js&"
export * from "./FooterLogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports